'use client'
import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { YANDEX_METRIKA_ID } from '@/shared/constants/stubs'

export const AnalyticsTracker = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  useEffect(() => {
    const url = `${pathname}?${searchParams}`
    if (typeof window !== 'undefined' && window.ym) {
      window.ym(YANDEX_METRIKA_ID, 'hit', url)
    }
  }, [pathname, searchParams])

  return null
}
